export const WEATHER_ICON_MAP: Record<number, number> = {
  1: 2,
  48: 45,
  51: 61,
  53: 63,
  55: 65,
  56: 66,
  57: 67,
  80: 65,
  81: 65,
  82: 65,
  85: 75,
  86: 75,
} as const;

export const weatherIconCorrection = (code: number) => {
  if ([48, 51, 53, 55, 56, 57].includes(code))
    return { code: WEATHER_ICON_MAP[code], sun: false };
  if ([1, 80, 81, 82, 85, 86].includes(code))
    return { code: WEATHER_ICON_MAP[code], sun: true };

  return { code, sun: false };
};

export const getDetailedIconName = (
  code: number,
  isNight = false,
): { code: string; sun: boolean } => {
  const corrected = weatherIconCorrection(code);

  return {
    code: isNight && corrected.code === 0 ? "0.night" : `${corrected.code}`,
    sun: corrected.sun,
  };
};

export const getWeatherIcon = (code: number): number => {
  if (code === 0 || code === 3) return code;
  return 2;
};

const NIGHT_VARIANT_ICONS = new Set<number>([0]);

export const getWeatherIconName = (code: number, isNight = false): string => {
  const icon = getWeatherIcon(code);
  return isNight && NIGHT_VARIANT_ICONS.has(icon) ? `${icon}.night` : `${icon}`;
};
